// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"617b38e3","349":"fb58503a","434":"792fcb64","519":"d9808709","583":"b15951f3","640":"9df1a10f","655":"98f15887","739":"49ca21aa","787":"7f5bd347","815":"3ad82eb1","907":"05bda392","945":"04dd8a5a","954":"d71f3094","979":"db14072f"}[chunkId] + ".chunk.js";
};